function AEIcon() {
  return (
    <div className="w-10 h-10 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center">
      <span className="text-white text-label font-bold">Ae</span>
    </div>
  )
}

function LottieIcon() {
  return (
    <div className="w-10 h-10 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center">
      <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 6h16M4 10h12M4 14h16M4 18h8" strokeLinecap="round" />
      </svg>
    </div>
  )
}

function DeviceIcon() {
  return (
    <div className="w-10 h-10 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center">
      <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="4" width="8" height="14" rx="1" />
        <rect x="13" y="2" width="9" height="18" rx="1" />
        <circle cx="7" cy="15" r="1" fill="currentColor" />
      </svg>
    </div>
  )
}

function FlowArrow() {
  return (
    <div className="flex items-center justify-center px-0.5 shrink-0">
      <svg viewBox="0 0 32 12" className="w-5 h-3 md:w-8 text-text-muted" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M0 6h28M24 2l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

export default function AEtoLottiePipeline() {
  return (
    <div className="bg-surface-hover rounded-xl p-4 md:p-6">
      <div className="grid grid-cols-[1fr_auto_1fr_auto_1fr] gap-y-2">
        {/* Row 1: Icons + arrows – always at same height */}
        <div className="flex justify-center"><AEIcon /></div>
        <FlowArrow />
        <div className="flex justify-center"><LottieIcon /></div>
        <FlowArrow />
        <div className="flex justify-center"><DeviceIcon /></div>

        {/* Row 2: Labels */}
        <div className="flex flex-col items-center gap-0.5">
          <p className="text-label text-text-primary text-center">After Effects</p>
          <p className="text-caption text-text-muted text-center">Complex rigging</p>
        </div>
        <div />
        <div className="flex flex-col items-center gap-0.5">
          <p className="text-label text-text-primary text-center">Lottie JSON</p>
          <p className="text-caption text-text-muted text-center">Lightweight export</p>
        </div>
        <div />
        <div className="flex flex-col items-center gap-0.5">
          <p className="text-label text-text-primary text-center">Cross-Platform</p>
          <p className="text-caption text-text-muted text-center">Mobile, Web, Prototype</p>
        </div>
      </div>
    </div>
  )
}
